import { useSelector } from "react-redux";

export const useGetPageData = () => {
  const { pageData, fields, pageKey } = useSelector((store) => store.OriginalTableData);
  
  return { pageData, fields, pageKey };
};
